module.exports = __webpack_public_path__ + "static/media/8.87c3981d.svg";